import { YupSchema } from 'services/yup/types'
import { yupArray, yupIgnore, yupNumber } from 'services/yup'
import {
  BaseProductPackage,
  BaseProductPreset,
} from 'services/api/entities/catalog/packages/common'
import { packageBaseVS, presetBaseVS } from './packageBase'

export const baseProductPresetVS: YupSchema<BaseProductPreset> =
  presetBaseVS.shape({
    quantityMultiplier: yupNumber(),
  })

export const baseProductPackageVS: YupSchema<BaseProductPackage> =
  packageBaseVS.shape({
    products: yupArray(baseProductPresetVS).min(1),
    isBundledPackage: yupIgnore(),
  })
